export interface MerchantRuntimeConfig {
  apiBaseUrl: string;
  platformClientId?: string | undefined;
  platformHost?: string | undefined;
  appOrigin?: string | undefined;
}

export function readMerchantRuntimeConfig(): MerchantRuntimeConfig {
  return {
    apiBaseUrl: readRequiredConfig(
      "VITE_PRICE_RESCUE_API_BASE_URL",
      import.meta.env.VITE_PRICE_RESCUE_API_BASE_URL ?? import.meta.env.VITE_API_BASE_URL,
    ),
    ...optionalConfig(
      "platformClientId",
      readOptionalConfig("VITE_SHOPIFY_CLIENT_ID", import.meta.env.VITE_SHOPIFY_CLIENT_ID),
    ),
    ...optionalConfig("platformHost", readPlatformHost()),
    ...optionalConfig(
      "appOrigin",
      typeof window === "undefined" ? undefined : window.location.origin,
    ),
  };
}

function readPlatformHost(): string | undefined {
  if (typeof window === "undefined") return undefined;

  return (
    new URLSearchParams(window.location.search).get("host") ??
    readOptionalConfig("VITE_SHOPIFY_HOST", import.meta.env.VITE_SHOPIFY_HOST)
  );
}

function readRequiredConfig(name: string, value: string | undefined): string {
  if (value !== undefined && value.length > 0) return value;

  throw new Error(`Missing merchant UI runtime config: ${name}`);
}

function readOptionalConfig(_name: string, value: string | undefined): string | undefined {
  return value === undefined || value.length === 0 ? undefined : value;
}

function optionalConfig<Key extends keyof MerchantRuntimeConfig>(
  key: Key,
  value: MerchantRuntimeConfig[Key] | undefined,
): Partial<MerchantRuntimeConfig> {
  return value === undefined ? {} : ({ [key]: value } as Partial<MerchantRuntimeConfig>);
}
